import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { apiResponse } from "../../utils/apiResponse";
import Loader from "../Loader/Loader";
import { commonService } from "../../utils/commonService";

const SingleDayPricingForcastModal = ({
  closeModal,
  asOfDate,
  selectedDate,
  propertyCode,
}) => {
  const [loading, setLoading] = useState(false);
  const [groupWiseList, setGroupWiseList] = useState(null);
  const groupWiseListRef = useRef();
  groupWiseListRef.current = groupWiseList;

  const getGroupData = async () => {
    setLoading(true);
    let groupResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.DAILY_SUMMARY.SINGLE_DAYBYDAY_SEGMENT_WISE_FORECAST,
        body: {
          asofdate: asOfDate,
          startdate: commonService.getDateInDBFormat(selectedDate),
          enddate: commonService.getDateInDBFormat(selectedDate),
          propertycode: propertyCode,
        },
      },
      false,
    );

    let response = apiResponse(false, groupResponse);
    if (response?.isValidate) {
      setLoading(false);
      setGroupWiseList(response?.data?.data);
    }

    if (!response?.isValidate) {
      setLoading(false);
      setGroupWiseList(null);
    }
  };

  useEffect(() => {
    getGroupData();
  }, [asOfDate, selectedDate]);

  return (
    <div className="GroupNameModalMain ToolsSingleTicketPopUpMain singleDateSummaryModalMain">
      <div className="GroupNameModalHeader">
        <h2>{"Single Day"} Pricing & Forecast Summary</h2>
        <button
          id={commonService.generateGlobalClickTrackerID("SingleDayPricingForcastModal","pricing-forecast-close-btn", selectedDate)} 
          className="btn-close"
          onClick={closeModal}
        ></button>
      </div>
      <div className="singleDateSummaryModalContent">
        <div
          className="ViewPropertySetupTable"
          style={{
            borderRadious: "5px",
            border: "1px solid #cfd9f8",
            maxHeight: "175px",
            overflow: "auto",
          }}
        >
          <div className="table__container">
            <div className="stripped__table">
              <Table className="positionStaticTable heatMapTbl table">
                <thead className="tbl-header-sticky">
                  <tr>
                    <th className="border_right">Market Segment</th>
                    <th className="border_right text-center">Actual Rooms</th>
                    <th className="border_right text-center">Forecast Rooms</th>
                    <th className="border_right text-end">Actual ADR</th>
                    <th className="border_right text-end">Forecast ADR</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr style={{ height: "80px", position: "relative" }}>
                      <Loader />
                    </tr>
                  ) : groupWiseList?.length > 0 ? (
                    groupWiseList?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className="border_right">
                            {item.marketsegment_term ? item.marketsegment_term : ""}
                          </td>
                          <td className="border_right text-center">
                            {item.actualroomsold ? item.actualroomsold : 0}
                          </td>
                          <td className="border_right text-center">
                            {item.forecastroomsold ? item.forecastroomsold : 0}
                          </td>
                          <td className="border_right text-end">
                            {commonService.formateAmount(
                              item.actualrevenue ? item.actualrevenue : 0,
                            )}
                          </td>
                          <td className="border_right text-end">
                            {commonService.formateAmount(
                              item.forecasterevenue ? item.forecasterevenue : 0,
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr className="text-center">
                      <td colSpan={5}>No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleDayPricingForcastModal;
